import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchRecommendedDevices } from 'store/common/recommendations/actions';
import {
  getRecommendationTabsActiveTab,
  getRecommendationTabsIsFetching,
} from 'store/ProductDetails/recommendationTabs/selectors';
import { PLACEMENTS } from 'store/common/recommendations/constants';
import { getIsDigineticaRecommendsAvailable } from 'store/common/settings/selectors';

export const fetchRecommendationTabDevices = createAsyncThunk(
  'recommendedTabs/fetchRecommendationTabDevices',
  (slug: PLACEMENTS, { dispatch }) => dispatch(fetchRecommendedDevices(slug)),
  {
    condition: (slug: PLACEMENTS, { getState }) => {
      const state = getState();
      const activeTab = getRecommendationTabsActiveTab(state);
      const isFetching = getRecommendationTabsIsFetching(state);
      const featureFlag = getIsDigineticaRecommendsAvailable(state);

      if (!featureFlag) return false; // фича выключена - отменяем
      return !(slug === activeTab || isFetching);
    },
  },
);
